import { useRegisterConfirmModal } from "./GlobalConfirmModal/useRegisterConfirmModal";
import { useRegisterTextPromptModal } from "./GlobalTextPromptModal/useRegisterTextPromptModal";
import { StackControls } from "./useModalStack";

// a workaround to export a function that doesn't get defined until first render cycle
// ... unconventional, but works and hopefully quite straight-forward
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let __GLOBAL_REGISTRATORS_SINGLETON__: Registrators = {} as any;

const useModalRegistrators = (controls: StackControls) => {
  const registrators = {
    confirm: useRegisterConfirmModal(controls),
    textPrompt: useRegisterTextPromptModal(controls),
  };

  __GLOBAL_REGISTRATORS_SINGLETON__ = registrators;

  return registrators;
};

export default useModalRegistrators;
export type Registrators = ReturnType<typeof useModalRegistrators>;

export const globalModals: Registrators = new Proxy(
  {} as Registrators, // I <3 PRETTIER
  {
    get(_, key: keyof Registrators) {
      if (__GLOBAL_REGISTRATORS_SINGLETON__[key]) {
        return __GLOBAL_REGISTRATORS_SINGLETON__[key];
      }

      throw new Error("Trying to access invalid registrator");
    },
  }
);
